/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type UnlinkResourcePathParams = NonNullable<operations['unlinkResource']['parameters']['path']>;

export type UnlinkResourceRequestBody = OperationRequestBodyContent<operations['unlinkResource']>;

export interface Input extends UnlinkResourcePathParams {
  apiVersion?: string;
  body: UnlinkResourceRequestBody;
  header: NonNullable<operations['unlinkResource']['parameters']['header']>;
}

export async function unlinkResource(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/views/{viewKey}/link/{resourceType}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
